import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ClinicProvider } from "@/store/ClinicContext";
import { AuthProvider } from "@/store/AuthContext";
import { PlanProvider } from "@/store/PlanContext";
import { PlanSwitcher } from "@/components/plan/PlanGating";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { TrialBanner } from "@/components/TrialBanner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Register from "@/pages/Register";
import SoloOnboarding from "@/pages/SoloOnboarding";
import Assinar from "@/pages/Assinar";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Dashboard from "@/pages/Dashboard";
import Atendimento from "@/pages/Atendimento";
import Financeiro from "@/pages/Financeiro";
import Medicos from "@/pages/Medicos";
import MedicoShell from "@/pages/MedicoShell";
import Recepcao from "@/pages/Recepcao";
import Diagnostico from "@/pages/Diagnostico";
import Backoffice from "@/pages/Backoffice";
import DoctorPublicPage from "@/pages/DoctorPublicPage";
import ConsultaSucesso from "@/pages/ConsultaSucesso";
import SalaTelemedicina from "@/pages/SalaTelemedicina";
import Ativar from "@/pages/Ativar";
import AgendarApresentacao from "@/pages/AgendarApresentacao";

function App() {
  return (
    <div className="App">
      <ClinicProvider>
        <PlanProvider>
          <BrowserRouter>
            <AuthProvider>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/esqueci-senha" element={<ForgotPassword />} />
                <Route path="/redefinir-senha" element={<ResetPassword />} />
                <Route path="/cadastro" element={<Register />} />
                <Route path="/cadastro/solo" element={<SoloOnboarding />} />
                <Route path="/assinar" element={<Assinar />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/crm" element={<Backoffice />} />
                <Route path="/agendar" element={<AgendarApresentacao />} />
                <Route path="/agenda" element={<ProtectedRoute allow={["admin"]}><Dashboard /></ProtectedRoute>} />
                <Route path="/atendimento" element={<ProtectedRoute allow={["admin"]}><Atendimento /></ProtectedRoute>} />
                <Route path="/financeiro" element={<ProtectedRoute allow={["admin"]}><Financeiro /></ProtectedRoute>} />
                <Route path="/medicos" element={<ProtectedRoute allow={["admin"]}><Medicos /></ProtectedRoute>} />
                <Route path="/diagnostico" element={<ProtectedRoute allow={["admin"]}><Diagnostico /></ProtectedRoute>} />
                <Route path="/recepcao" element={<ProtectedRoute allow={["secretaria"]}><Recepcao /></ProtectedRoute>} />
                <Route path="/portal" element={<ProtectedRoute allow={["medico"]}><MedicoShell /></ProtectedRoute>} />
                <Route path="/consulta/sucesso" element={<ConsultaSucesso />} />
                <Route path="/sala/:roomId" element={<SalaTelemedicina />} />
                <Route path="/ativar" element={<Ativar />} />
                <Route path="/:slug" element={<DoctorPublicPage />} />
              </Routes>
              <TrialBanner />
              <PlanSwitcher />
            </AuthProvider>
          </BrowserRouter>
          <Toaster position="bottom-right" richColors closeButton />
        </PlanProvider>
      </ClinicProvider>
    </div>
  );
}

export default App;
